<template>
  <div class="classification">
    <!-- 标题栏 -->
    <van-nav-bar left-arrow title="分类" @click-left="onClickLeft" />
    <!-- 内容 -->
    <div class="page">
      <div class="disp-flex">
        <div class="kqb-section" v-for="(item,index) in goodsCategoryList" @click="pageJump('/curriculumSchedule',item)" :key='index'>
          <div class="classifiction">
            <span>{{item.goodsCategoryName}}</span>
            <span>已有{{item.sumStudy}}人学习</span>
          </div>
        </div>
        <!--最后一个是站位用的，不能删掉-->
        <div class="kqb-section" style="background-color: transparent;">&nbsp;</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'classification',
  data () {
    return {
      message: '',
      // fileList: [
      //   { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
      //   // Uploader 根据文件后缀来判断是否为图片文件
      //   // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
      //   { url: 'https://cloud-image', isImage: true }
      // ]
      goodsCategoryList: []
    }
  },
  created () {
    this.getGoosCategory()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    // 页面跳转
    pageJump (uri, item) {
      const thisObj = this
      let queryData = {
        goodsCategoryName: item.goodsCategoryName,
        goodsCategoryId: item.goodsCategoryId
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    getGoosCategory () {
      var thisObj = this
      var storeId = this.$root.userInfo.storeId
      thisObj.$api.get(thisObj.requestUrl + '/knowledge/goods/category/getKnowledgeGoodsCategory?fromDevice=h5&storeId=' + storeId, {}).then(res => {
        console.log(res)
        if (res.resultCode === 200 && res.success) {
          thisObj.goodsCategoryList = res.resultData
        } else {
          thisObj.$util.requetServerError(res.resultMsg)
        }
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    }
  }
}
</script>
<style scoped>
.page {
  background: #fff;
}

.disp-flex {
  flex-wrap: wrap;
  padding: 0 5px;
}

.kqb-section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: 326px;
  height: 216px;
  margin: 16px 22px;
  border-radius: 10px;
  color: #fff;
  background: rgba(244, 244, 244, 1);
  border-radius: 5px;
}

.classifiction {
  text-align: center;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.classifiction span {
  display: block;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(158, 158, 158, 1);
}

.classifiction span:first-child {
  margin: 0 0 20px 0;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(63, 63, 63, 1);
}
</style>
